import { render, staticRenderFns } from "./LightControlConfig.vue?vue&type=template&id=687ef253&scoped=true&"
import script from "./LightControlConfig.vue?vue&type=script&lang=js&"
export * from "./LightControlConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "687ef253",
  null
  
)

export default component.exports